var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-alert',{staticClass:"h-full",attrs:{"description":_vm.$t('send_message_actions_warning')}})}
var staticRenderFns = []

export { render, staticRenderFns }